import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/Layout/layout"
import { MobileHeader, MobileFeatures, MobileAccomplishment, MobileSolution, MobileAdviser, MobileApplication, MobileBottomNav } from "../components/mobilelp"
import Helmet from "react-helmet"

function MobileLpPage({
                        location,
                        pageContext: { language },
                        data: { site, allDataYaml: { edges: [ { node: { mobilelp }} ]} }
}) {
  const { title, description, keywords } = mobilelp

  const imageOG = `${site.siteMetadata.domain}/${language === "ja" ? "og_mobile_ja.png" : "og_mobile_en.png"}`

  const jsonld = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    "name": title,
    "url": location,
  }

  const lightBg = {'backgroundColor':"#f6f9fb"}

  return (
    <Layout location={location} title={title} description={description} imageURL={imageOG} isDarkHeader={false} hasCTA={false} isMobileNativePage={true}>
      <Helmet>
        <meta name="keywords" content={keywords} />

        <script type="application/ld+json">
          {JSON.stringify(jsonld)}
        </script>
      </Helmet>

      <section id="mobile-header" className="p-0">
        <MobileHeader language={language} />
      </section>

      <section className="py-0" style={lightBg}>
        <MobileSolution language={language} />
      </section>

      <section>
        <MobileAccomplishment language={language} />
      </section>

      <section className="py-0">
        <MobileFeatures language={language} />
      </section>

      <section id="adviser" className="pb-0" style={lightBg}>
        <MobileAdviser language={language} />
      </section>

      <section id="mobile-application-form" className="pt-0">
        <MobileApplication language={language}  />
      </section>

      <div className="d-block d-sm-none">
        <MobileBottomNav language={language} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($language: String) {
    site {
      siteMetadata {
        domain
      }
    }
    allDataYaml(filter: {language: {eq: $language}}) {
      edges {
        node {
          mobilelp {
            title
            description
            keywords
          }
        }
      }
    }
  }
`

export default MobileLpPage;
